/**
 * @fileoverview Defines the `Env` type and functions `getEnv`, `isProd`, `isStaging`, and `isDev` to determine the current application environment. The environment is based on the `import.meta.env.MODE` variable.
 */

export type Env = 'development' | 'staging' | 'production'

export function getEnv(): Env {
  if (import.meta.env.MODE === 'prod-ref') {
    return 'production'
  }
  if (import.meta.env.MODE === 'ref-dev-mjd') {
    return 'staging'
  }
  return 'development'
}

export function isProd() {
  return getEnv() === 'production'
}

export function isStaging() {
  return getEnv() === 'staging'
}

export function isDev() {
  return getEnv() === 'development'
}
